import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { JobClickCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class BoardService {
  constructor(private http: HttpClient) { }

  save(board: any) {
    return this.http.post<any>(environment.app.apiUrl + 'board/save', board).toPromise();
  }

  get(boardId: string) {
    return this.http.get<any>(environment.app.apiUrl + 'board/' + boardId).toPromise();
  }
  getTemplates(): Promise<string[]> {
    return this.http.get<any>(environment.app.apiUrl + 'board/templates').toPromise();
  }

  html(boardId: string) {
    return this.http.get(environment.app.apiUrl + 'board/html/' + boardId + '?nocache=1', { responseType: 'text' }).toPromise();
  }

  preview(board: any) {
    return this.http.post<any>(`${environment.app.apiUrl}board/preview`, board).toPromise();
  }
  getPreviewUrl(board: any) {
    if (!board) return null;
    var path = environment.production ? 'https://api.karpishe.com/api/' : environment.app.apiUrl;
    // if (board.Id) return path + 'board/preview/' + board.Id; else
    return path + 'board/preview?board=' + encodeURIComponent(JSON.stringify(board));
  }

  jobs(boardId: string, from = 0, count = 10) {
    return this.http.get<{ board: any, jobs: any[], total: number }>(environment.app.apiUrl + `board/jobs/${boardId}/${count}/${from}`).toPromise();
  }

  // Publisher
  mine(criteria: any, from = 0, limit = 50) {
    return this.http.post<{ boards: any[], total: number }>(environment.app.apiUrl + 'board/mine', criteria, { params: { from: from.toString(), limit: limit.toString() } }).toPromise();
  }
  // Operator
  all(criteria: any, from = 0, limit = 50) {
    return this.http.post<{ boards: any[], total: number }>(environment.app.apiUrl + 'board/all', criteria, { params: { from: from.toString(), limit: limit.toString() } }).toPromise();
  }

  report(criteria: JobClickCriteria, interval?: any) {
    return this.http.post<any>(environment.app.apiUrl + `board/report/${interval || ''}`, criteria).toPromise();
  }
}
